const PLANS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  STARTED: 'started',
  SUGGESTED: 'suggested',
  CHALLENGES: 'challenges',
  LOGGED: 'logged',
  NON_LOGGED: 'nonLogged',
  DATA: 'data',
  SMART: 'smart',
  RECOMMENDED: 'recommended'
}

export { PLANS_KEY }
